<template>
  <div style="position: relative;z-index: 1">
    <div class="px-lg-5 me-lg-2">
      <div class="mx-auto image-backdrop d-flex flex-column">
        <img class="my-auto img1"
             :src="`${baseUrl}proxy/${horusBase64.stringToBase64URLSafe(alert.images?.[0]?.url)}`"/>
        <img  class="my-auto img2"
             :src="`${baseUrl}proxy/${horusBase64.stringToBase64URLSafe(alert.images?.[0]?.url)}`"/>
      </div>
    </div>
    <div ref="content" class="col-12 col-md-11 col-lg-10 col-xl-9 p-2 p-sm-5 mx-auto cert-page-content"
         style="position: relative; margin-top: -50px; z-index: 1;">
      <div class="col-12 col-md-11 col-lg-10 col-xl-9" style="margin-bottom: 50px">
        <div v-if="loaded" class="cert-title">{{ alert.title }}</div>
        <div v-if="loaded" class="cert-subtitle">{{ alert.datetime.human }}</div>
      </div>
      <div class="responsive-text" v-if="loaded" v-html="alert.bodytext"></div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.cert-title {
  font-weight: 800;
  font-size: 1.5rem;
}

.cert-subtitle {
  font-weight: 600;
  opacity: 0.75;
  font-size: 0.9rem;
}

.image-backdrop {
  position: relative;
  top: 0;
  left: 0;
  width: fit-content;
  max-width: 100%;
  border-radius: 12px;
  z-index: -1;
  max-height: 50vh;
  overflow: hidden;

  .img1 {
    opacity: 0;
  }

  .img2 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100vw;
  }
}


</style>
<style>

</style>
<script>
import api from "@/api";
import horusBase64 from "@/components/horusBase64";

export default {
  name: "AlertDetails",
  computed: {
    horusBase64() {
      return horusBase64
    }
  },
  props: {
    cardBg: String
  },
  data() {
    return {
      id: "",
      alert: "",
      type: "",
      loaded: false,
      baseUrlCyber: process.env.VUE_APP_BASE_URL_CYBER,
      baseUrl: process.env.VUE_APP_BASE_URL,
    };
  },
  methods: {
    loadAlert() {
      const path = `api/${localStorage.getItem("alert_type")}/${localStorage.getItem("alert_id")}`;
      api
          .get(`${process.env.VUE_APP_BASE_URL}proxy/${horusBase64.stringToBase64URLSafe(path)}`)
          .then((response) => {
            this.alert = response.data;
            this.alert.bodytext = this.alert.bodytext?.replace(/&nbsp;/g, " ");
            this.loaded = true;
          })
          .catch((error) => {
            error;
          });
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.type = this.$route.params.type;
    if (this.id != null && this.type != null) {
      localStorage.setItem("alert_id", this.id);
      localStorage.setItem("alert_type", this.type);
    }
    if (this.id == null)
      this.$router.push({path: "/home"});

    this.loadAlert();
  },
  mounted() {
    this.$anim.fadeInBottomOpaque(this.$refs["content"], 50);
  }
};
</script>